import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import * as R from 'ramda'


import RaisedButton from 'material-ui/RaisedButton'
import { MentionsInput, Mention } from 'react-mentions'

import AttachButton from '../Attachments/AttachButton'
import AttachmentsList from '../Attachments/AttachmentsList'

import commentActions from 'actions/commentActions'

import { doc } from 'selectors/common'
import { managersData, propertiesData, tenantsData, repairmenData, agentsData, ownersData } from 'selectors/mentions'
import { attachmentsByObjectID } from 'selectors/attachments'

import { linkedText } from 'utils/commentsText'
import inputStyles from './inputStyles'

let select = (state, props) => ({
	...state
  , commentBuffer: state.commentBuffer
  , userID: state.session.userID
  , object: doc(state, props.objectID)
  , attachments: attachmentsByObjectID(state)
  , managers: managersData(state)
  , properties: propertiesData(state)
  , tenants: tenantsData(state)
  , repairmen: repairmenData(state)
  , agents: agentsData(state)
  , owners: ownersData(state)
})

export class CommentForm extends Component {
	render(){
		let { props } = this
		let mode = props.commentBuffer.mode
		return(
			<div
				className="form-holder"
				style={{
					backgroundColor: "#f4f4f4"
				  , marginBottom: "15px"
				}}
			>
				<span
					style={{
						fontSize: "12px"
					  , marginLeft: "10px"
					  , display: "inline-block"
					  , marginTop: "10px"
					  , color: "#a8b5b9"
					}}
				>
					{(mode == 'new')?'Add comment':'Edit comment'}
				</span>
				<div
					style={{
						padding: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "10px 0" : "0px 20px 10px 10px"
					}}
				>
					<form
						key={`${this.props.objectID}-mainForm`}
						onSubmit={(evt) =>{
							evt.preventDefault()
							props.COMMENT_SAVE({
								_id: props.commentBuffer.commentID
							  , contents: props.commentBuffer.contents
							  , objectID: props.objectID
							  , userID: props.userID
							  , type: 'comment'
							})
							return false
							}
						}
						style={{
							marginTop: "10px"
						  , width: "100%"
						  , display: "inline-block"
						  , position: "relative"
						}}
					>
						<MentionsInput
							value={ (props.commentBuffer && props.commentBuffer.contents)? props.commentBuffer.contents : "" }
							onChange={ (evt) => props.COMMENT_CHANGE(evt.target.value) }
							style={inputStyles}
							markup="@[__display__](__type__:__id__)"
						>
							<Mention
								type="property"
								trigger="^"
								data={ props.properties }
								renderSuggestion={ (suggestion, search, highlightedDisplay) => (
									<div className="property">
									{ highlightedDisplay }
									</div>
								)}
								appendSpaceOnAdd={true}
								style={{ borderBottom: '1px solid black'}}
							/>
							<Mention
								type="tenant"
								trigger="$"
								data={ props.tenants }
								renderSuggestion={ (suggestion, search, highlightedDisplay) => (
									<div className="tenant">
									{ highlightedDisplay }
									</div>
								)}
								appendSpaceOnAdd={true}
								style={{ borderBottom: '1px solid black'}}
							/>
							<Mention
								type="repairman"
								trigger="*"
								data={ props.repairmen }
								renderSuggestion={ (suggestion, search, highlightedDisplay) => (
									<div className="repairman">
									{ highlightedDisplay }
									</div>
								)}
								appendSpaceOnAdd={true}
								style={{ borderBottom: '1px solid black'}}
							/>
							<Mention
								type="agent"
								trigger="%"
								data={ props.agents }
								renderSuggestion={ (suggestion, search, highlightedDisplay) => (
									<div className="agent">
									{ highlightedDisplay }
									</div>
								)}
								appendSpaceOnAdd={true}
								style={{ borderBottom: '1px solid black'}}
							/>
							<Mention
								type="manager"
								trigger="@"
								data={ props.managers }
								renderSuggestion={ (suggestion, search, highlightedDisplay) => (
									<div className="manager" style={{display: "flex"}}>
										<div>
											{props.attachments[suggestion.id]?
												<div style={{width: "20px", height: "20px", borderRadius: "100%", marginRight: "10px", overflow: "hidden"}}>
													<img src={props.attachments[suggestion.id][0].url} width="20" />
												</div>
												:
												<img src={'/' + process.env.REACT_APP_NAME + "/static/img/agents_g48.png"} width="20" style={{marginRight: "10px"}} />
											}

										</div>
										<div>
											{ highlightedDisplay }
										</div>
									</div>
								)}
								appendSpaceOnAdd={true}
								style={{ borderBottom: '1px solid black'}}
							/>
							<Mention
								type="owner"
								trigger="&"
								data={ props.owners }
								renderSuggestion={ (suggestion, search, highlightedDisplay) => (
									<div className="manager" style={{display: "flex"}}>
										<div>
											{props.attachments[suggestion.id]?
												<div style={{width: "20px", height: "20px", borderRadius: "100%", marginRight: "10px", overflow: "hidden"}}>
													<img src={props.attachments[suggestion.id][0].url} width="20" />
												</div>
												:
												<img src={'/' + process.env.REACT_APP_NAME + "/static/img/agents_g48.png"} width="20" style={{marginRight: "10px"}} />
											}

										</div>
										<div>
											{ highlightedDisplay }
										</div>
									</div>
								)}
								appendSpaceOnAdd={true}
								style={{ borderBottom: '1px solid black'}}
							/>
						</MentionsInput>
						<AttachButton objectID={props.commentBuffer.commentID} path={props.path} icon={true} style={{position:"absolute", right: "0", top: "10px"}}/>
						<div
							className="attachments"
							style={{
								marginBottom: "5px"
							}}
						>
							<AttachmentsList objectID={props.commentBuffer.commentID} removable={true} icon={true} />
						</div>
						<RaisedButton
							label={(mode == 'edit')?"save":"post"}
							type="Submit"
							backgroundColor="#3cd2ae"
							labelColor="#FFF"
							className="submit-btn"
							style={{
								width: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "calc(100% - 10pt)": "95px"
							  , height: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "40pt" : "35px"
							  , display: "block"
							  , float: "right"
							}}
							labelStyle={{
								borderRadius: "6px"
							  , lineHeight: "36px"
							}}
						/>
						<p
							style={{
								margin: "0"
							  , color: "#b3bdc2"
							}}
						>
							^ - property, $ - tenant, * - repairman, % - agent, @ - manager, & - owner
						</p>
					</form>
				</div>
			</div>
		)
	}
}

export default connect(select, commentActions)(CommentForm)



// WEBPACK FOOTER //
// ./src/components/Comments/CommentForm.js